import TypographySecondaryScreen from './TypographySecondaryScreen'

export default TypographySecondaryScreen
